import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomRoomAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomRoomAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomRoomAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.ida"
        className="room-form__room-air"
        label={t("Room.ida")}
        unit="m³/h"
        color="#b3b3b3"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__room-air__input"
      />
    )
  }
)
